<template lang="pug">
  v-stepper(v-model="e1")
    v-snackbar(
      v-model="snackbar"
      :timeout="10000"
      color='error'
    ) {{ snackbarMessage }}  
    v-stepper-header
      v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
      v-divider
      v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
      v-divider
      v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus

    v-stepper-items
      v-stepper-content(step="1")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Judul Pekerjaan
              v-flex(xs7 sm5)
                v-text-field(id="fipel-judul-pekerjaan" class="inputDefault" v-model='judulPekerjaan' label="Judul Pekerjaan")
              v-flex(xs1 sm4)

              v-flex(xs3 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Tanggal Perizinan
              v-flex(xs4 sm2)
                v-menu(
                  v-model="startMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="startDate"
                      label="mulai dari"
                      prepend-icon="event"
                      id="fipel-tgl-izin-start"
                      readonly
                      v-on="on")
                  v-date-picker(id="fipel-tgl-picker-start" v-model="startDate" @input="clearDate" :min="todayDate")
              v-flex(xs4 sm2)
                v-menu(
                  v-model="endMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="endDate"
                      label="sampai dengan"
                      prepend-icon="event"
                      id="fipel-tgl-izin-end"
                      readonly
                      v-on="on")
                  v-date-picker(id="fipel-tgl-picker-end" v-model="endDate" @input="endMenu = false" :min="startDate")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3)
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Department / Divisi
              v-flex(xs7 sm5)
                v-row
                  v-col
                    v-autocomplete(
                      class="inputDefault"
                      v-model="deptDivisi"
                      id="fipel-dept-divisi"
                      :items="dataUsers.department"
                      label="Department")
                  v-col
                    v-text-field(id="fipel-divisi" class="inputDefault" v-model='divisi' counter="100" maxlength="100" label="Divisi")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Lokasi Pekerjaan
              v-flex(xs7 sm5)
                v-row
                  v-col
                    v-autocomplete(
                        class="inputDefault"
                        label="Lokasi Pekerjaan" 
                        id="fipel-lokasi"
                        v-model="lokasi" 
                        :items="locations.data" 
                        no-data-text="No Data" 
                        color="blue-grey lighten-2" 
                        item-text="location_name" 
                        item-value="data" 
                        clearable
                        chips
                        multiple)
                  v-col
                    v-text-field(id="fipel-sub-lokasi" class="inputDefault" v-model='subLokasi' label="Sub Lokasi" counter="100" maxlength="100" height="42")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Perusahaan
              v-flex(xs7 sm5)
                v-autocomplete(
                  class="inputDefault"
                  v-model="perusahaan"
                  id="fipel-perusahaan"
                  :items="dataUsers.companies"
                  label="Perusahaan")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Nama Pemegang Izin
              v-flex(xs7 sm5)
                v-menu(
                  v-model="searchPemegangMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="pemegangIzin.name"
                      label="Pemegang Izin"
                      id="fipel-pemegang-izin"
                      readonly
                      v-on="on")
                  PemegangModal(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin")
              v-flex(xs1 sm4)
        v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="2")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs12 sm12) 
                  h3(class="headerSection") Deskripsi Detail Pekerjaan (spesifik dan tidak boleh ada tambahan kegiatan diluar cakupan yang tertera dalam izin ini)
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fipel-detail-kerja" :editor="editor" v-model="detailPekerjaan" :config="editorConfig")
                  br

              v-flex(xs12 sm12) 
                  h3(class="headerSection") Potensi Bahaya / Risiko Yang Mungkin Ada
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fipel-bahaya" :editor="editor" v-model="bahaya" :config="editorConfig")
                  br
        v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="3")
        v-card(class="mb-12"
        height="auto")
          v-layout(row wrap)
              v-flex(xs12 sm12) 
                p(class="headerSection") Daftar Periksa
              v-flex(xs5 sm6)
                p(class="headerInput") Ada prosedur kerja (PPO, IK, AKA)?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fipel-ppoaka" class="selectInput" :items='checkOptions' v-model="ppoAka" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                p(class="headerInput") Prosedur sudah disosialisasikan?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fipel-prosedur" class="selectInput" :items='checkOptions' v-model="sosialisasiProsedur" label="Pilih" clearable) 
              
              v-flex(xs5 sm6)
                p(class="headerInput") Blaster/Petugas peledakan memadai, kompeten dan bersertifikat?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fipel-petugas-kompeten" class="selectInput" :items='checkOptions' v-model="petugasKompeten" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                p(class="headerInput") Alat peringatan/tanda/sirine tersedia?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fipel-alt-peringatan" class="selectInput" :items='checkOptions' v-model="alatPeringatan" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                p(class="headerInput") Rencana evakuasi personil dan peralatan memadai?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fipel-evakuasi" class="selectInput" :items='checkOptions' v-model="rencanaEvakuasi" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                p(class="headerInput") Box pelindung blaster?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fipel-pelindung-blaster" class="selectInput" :items='checkOptions' v-model="boxPelindungBlaster" label="Pilih" clearable) 
              
              v-flex(xs5 sm6)
                p(class="headerInput") Rencana blockade akses area peledakan?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fipel-blokade" class="selectInput" :items='checkOptions' v-model="rencanaBlokade" label="Pilih" clearable) 
              
              v-flex(xs5 sm6)
                p(class="headerInput") Petugas keamanan?
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fipel-keamanan" class="selectInput" :items='checkOptions' v-model="petugasKeamanan" label="Pilih" clearable) 

              v-flex(xs5 sm3) 
                h3(class="headerSection") Upload Dokumen
              v-flex(xs6 sm5 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
                v-file-input(id="fipel-document" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                  template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm5 class="attachmentName" v-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)")
                span(id="fipel-document") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                  v-icon mdi-close
              v-flex(xs1 sm4)

              v-flex(xs12 sm12) 
                  h3(class="headerSection") Pengendalian Risiko Tambahan
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fipel-resiko-tambahan" :editor="editor" v-model="pengendalianRisikoTambahan" :config="editorConfig")
                  br
              
              v-flex(xs12 sm12) 
                  h3(class="headerSection") Catatan Penting Lainnya
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fipel-ctt-penting" :editor="editor" v-model="catatanPentingLain" :config="editorConfig")
                  br

        v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        v-btn(class="mr-3" color='info' @click='submit(1)')
          v-icon insert_drive_file
          | &nbsp; Save as Draft
        v-btn(v-if='!submitClick' color='success' @click='submit(2)')
          v-icon send
          | &nbsp; Submit Request
        v-btn(text @click="backHome()") Cancel
</template>

<script>
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PemegangModal from "./PemegangModal.vue";
import { handleError } from "../helper/handleGlobalError.js";
export default {
  name: "AddPeledakan",
  components: {
    PemegangModal
  },
  props: {
    edit: { type: Boolean, default: false },
    users: Array
  },
  data() {
    return {
      e1: 1,
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        removePlugins : ['ImageUpload','MediaEmbed'],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
          // You need to configure the image toolbar, too, so it uses the new style buttons.
          toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
          styles: [
              // This option is equal to a situation where no style is applied.
              'full',
              // This represents an image aligned to the left.
              'alignLeft',
              // This represents an image aligned to the right.
              'alignRight'
          ]
        }
      },
      formCode: 'BIB-HSE-PPO-FRM-036-007',
      todayDate: new Date().toISOString().slice(0,10),
      perusahaan: '',
      deptDivisi: '',
      divisi: '',
      lokasi: '',
      subLokasi: '',
      pemegangIzin: '',
      judulPekerjaan: '',
      startDate: null,
      endDate: null,
      startMenu: false,
      endMenu: false,
      searchPemegangMenu: false,
      waktuMulaiMenu: false,
      waktuSelesaiMenu: false,
      startDateExtend: new Date().toISOString().substr(0, 10),
      endDateExtend: new Date().toISOString().substr(0, 10),
      startMenuExtend: false,
      endMenuExtend: false,

      checkOptions: ['Ya', 'Tidak'],
      ppoAka: '',
      sosialisasiProsedur: '',
      petugasKompeten: '',
      alatPeringatan: '',
      rencanaEvakuasi: '',
      boxPelindungBlaster: '',
      rencanaBlokade: '',
      petugasKeamanan: '',

      pengendalianRisikoTambahan: '',
      catatanPentingLain: '',
      detailPekerjaan: '',
      bahaya:'',

      snackbarMessage: '',

      uploadId: null,
      docPendukung: null,
      submitClick: false,
      status: 0,
      rules: [
        value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
      ],
      emptyUpload: new File([""], "", {
        type: "",
      })
    };
  },
  mounted: async function() {
    this.$store.dispatch("fetchLocations");
    this.uploadId = Date.now();
  },
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest"]),
    selectedLoc(){
      let tempLoc = []
      let locationCode;
      
      if(this.dataUsers.location instanceof Array){
        locationCode = this.dataUsers.location[0];
      }else{
        locationCode = this.dataUsers.location;
      }

      for(let i = 0; i < this.lokasi.length; i++){
        tempLoc.push({code: locationCode, name: this.lokasi[i]});
      }
      return tempLoc
    },
    isPage1Complete: function() {
      return !!this.judulPekerjaan &&  !!this.perusahaan && !!this.divisi && !!this.subLokasi && !!this.deptDivisi && (this.selectedLoc.length != 0) && !!this.pemegangIzin && !(this.selectedLoc.length<1) && !!this.startDate && !!this.endDate;
    }
  },
  methods: {
    updatePemegangIzin(user) {
      this.pemegangIzin = user;
    },
    clearDate(){
      this.endDate=null;
      this.startMenu = false;
    },
    formatDate:helper.formatDate,
    scrollTop(){
      window.scrollTo(0,0);
    },
    submit(status){
      this.submitClick = true;
      this.status = status;
      let formData = new FormData();
      if (this.edit) {
        formData.append('_id', this.dataEditRequest._id);
        formData.append('ipNo', this.dataEditRequest.ipNo);
        formData.append('ipWorkflow', JSON.stringify(this.dataEditRequest.ipWorkflow));
      }
      formData.append('ipStatus', this.status);
      formData.append('ipPerusahaan', this.perusahaan );
      formData.append('ipLocation', JSON.stringify(this.selectedLoc) );
      formData.append('ipPemegangIzin', JSON.stringify(this.pemegangIzin));
      formData.append('ipDeptDivisi', this.deptDivisi);
      formData.append('ipDivisi', this.divisi);
      formData.append('ipSubLokasi', this.subLokasi);
      formData.append('ipPelaksanaanStart', this.startDate );
      formData.append('ipPelaksanaanEnd', this.endDate );
      formData.append('ipJudulPekerjaan', this.judulPekerjaan);
      formData.append('ipPpoAka', this.ppoAka || 'N/A');
      formData.append('ipPetugasKompeten', this.petugasKompeten || 'N/A');
      formData.append('ipSosialisasiProsedur', this.sosialisasiProsedur || 'N/A');
      formData.append('ipAlatPeringatan', this.alatPeringatan || 'N/A');
      formData.append('ipRencanaEvakuasi', this.rencanaEvakuasi || 'N/A');
      formData.append('ipBoxPelindungBlaster', this.boxPelindungBlaster || 'N/A');
      formData.append('ipRencanaBlokade', this.rencanaBlokade || 'N/A');
      formData.append('ipPetugasKeamanan', this.petugasKeamanan || 'N/A');

      formData.append('ipPengendalianRisikoTambahan', this.pengendalianRisikoTambahan);
      formData.append('ipCatatanPentingLain', this.catatanPentingLain);
      formData.append('ipDetailPekerjaan', this.detailPekerjaan);
      formData.append('ipBahaya',this.bahaya);

      formData.append('uploadId', this.uploadId );
      formData.append('ipUser', JSON.stringify(this.dataUsers) );
      formData.append('ipForm', this.formCode);

      const config = {
        method: this.edit ? "put" : "post",
        url: `${this.API_URL}/v1/requests`,
        headers: {"Content-Type": "multipart/form-data", "Authorization": `Bearer ${this.$store.state.token}`},
        data: formData
      };

      axios(config).then(res => {
        this.$store.commit("temporaryData", res);
        this.$router.push("/my-permit");
      }).catch(error => {
        handleError(error, {
          setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
          showSnackbar: (show) => { this.snackbar = show; },
          disableLoader: () => {
            this.$store.state.loader = false;
          },
        });
        this.submitClick = false;
      });
    },
    // upload(name, paramFile){
    //   console.log(name)
    //   console.log(paramFile)
    //   if(paramFile.size > 10000000){
    //     // paramFile = null;
    //     // this.docPendukung = null;
    //     console.log("hellow")
    //   }else{
    //     // let formData = new FormData();
    //     // formData.append('uploadId', this.uploadId );
    //     // formData.append(name, paramFile );
    //     // axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
    //   }      
    // },
    deleteDocPendukung(name){
      let id = this.uploadId.toString();      
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    backStep(){
      this.e1--
    },
    docName(name){
      return this.$setFilename(name);
    }
  },
  watch: {
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
        formData.append('uploadId', this.uploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
    dataEditRequest: async function() {
      this.perusahaan = this.dataEditRequest.ipPerusahaan;
      // for (const item of this.locations) {
      //   let checked = false
      //   for (const element of this.dataEditRequest.ipLocation) {
      //     if(item.name == element.name) checked = true
      //   } 
      //   if(checked) this.lokasi.push(true)
      //   else this.lokasi.push(false)
      // }
      this.lokasi = [];
      for(const loc of this.dataEditRequest.ipLocation) {
        this.lokasi.push(loc.name);
      }
      this.subLokasi = this.dataEditRequest.ipSubLokasi;
      this.pemegangIzin = this.dataEditRequest.ipPemegangIzin;
      this.startDate = this.formatDate(this.dataEditRequest.ipPelaksanaanStart).slice(0,10);
      this.endDate = this.formatDate(this.dataEditRequest.ipPelaksanaanEnd).slice(0,10);
      this.deptDivisi = this.dataEditRequest.ipDeptDivisi;
      this.divisi = this.dataEditRequest.ipDivisi;
      this.judulPekerjaan = this.dataEditRequest.ipJudulPekerjaan;
      this.ppoAka = this.dataEditRequest.ipPpoAka;
      this.petugasKompeten = this.dataEditRequest.ipPetugasKompeten;
      this.sosialisasiProsedur = this.dataEditRequest.ipSosialisasiProsedur;
      this.alatPeringatan = this.dataEditRequest.ipAlatPeringatan;
      this.rencanaEvakuasi = this.dataEditRequest.ipRencanaEvakuasi;
      this.boxPelindungBlaster = this.dataEditRequest.ipBoxPelindungBlaster;
      this.rencanaBlokade = this.dataEditRequest.ipRencanaBlokade;
      this.petugasKeamanan = this.dataEditRequest.ipPetugasKeamanan;

      this.pengendalianRisikoTambahan = this.dataEditRequest.ipPengendalianRisikoTambahan;
      this.catatanPentingLain = this.dataEditRequest.ipCatatanPentingLain;
      this.detailPekerjaan = this.dataEditRequest.ipDetailPekerjaan;
      this.bahaya = this.dataEditRequest.ipBahaya;

      this.uploadId = this.dataEditRequest.uploadId;
      this.docPendukung = this.dataEditRequest.ipAttachmentFiles.docPendukung;
    },
  }
};
</script>

<style>
.ck-editor__editable {
    min-height: 300px;
    max-height: 300px;
    resize:none;
}
.mustFill {
  color: #EA5164;
}
</style>
